import React, { useMemo, useRef, createContext, use, useCallback } from 'react'

const Provider = createContext({
  getScrollOffset: (() => undefined) as () => number | undefined,
  setScrollOffset: (() => {}) as (value: number) => void,
})

/**
 * Persists layer tree UI state (e.g. scroll position) across mount/unmount cycles.
 * Wraps the conditionally rendered LayersTree so values survive when the tree is hidden.
 * Uses refs for storage to avoid re-renders on every scroll update.
 */
export const LayerTreePersistentState = (props: React.ComponentProps<any>) => {
  const { children } = props
  const scrollOffsetRef = useRef<number | undefined>(undefined)

  const getScrollOffset = useCallback(() => scrollOffsetRef.current, [])

  const setScrollOffset = useCallback((value: number) => {
    scrollOffsetRef.current = value
  }, [])

  const value = useMemo(
    () => ({ getScrollOffset, setScrollOffset }),
    [getScrollOffset, setScrollOffset]
  )

  return <Provider value={value}>{children}</Provider>
}

export const useLayerTreePersistentState = () => use(Provider)
